import { LiftInterface } from "../interfaces/Lift.interface";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_LIFT: LiftInterface = {
	id: "",
	bank_id: "",
	org_id: "",
	server_id: "",
	control_panel: {},
	direction: "",
	name: "",
	position: 0,
	type: "ELEVATOR",
	lift_floors: [
		{
			id: "",
			bank_floor_id: "",
			lift_id: "",
			front_door: false,
			rear_door: false,
		},
	],
};
